import { render, staticRenderFns } from "./Variations.vue?vue&type=template&id=99ee01d0&scoped=true&lang=html"
import script from "./Variations.vue?vue&type=script&lang=js"
export * from "./Variations.vue?vue&type=script&lang=js"
import style0 from "./Variations.vue?vue&type=style&index=0&id=99ee01d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ee01d0",
  null
  
)

export default component.exports